import script from "./CollapsibleSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollapsibleSection.vue?vue&type=script&setup=true&lang=ts"

import "./CollapsibleSection.vue?vue&type=style&index=0&id=a6b76ffc&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6b76ffc"]])

export default __exports__